import React from 'react';
import { useTranslation } from 'react-i18next';

import ImageSlider from './ImageSlider';

const FavoriteRooms = ({favoriteRoom, index}) => {

    const { t, i18n } = useTranslation();

  return (
    <div className='d-flex flex-column align-items-center'>
        {index % 2 == 0 ?
            <div className='row m-0 px-0 py-4 py-from-lg-3 bg-color-dark d-flex justify-content-center'>
                <div className='col-sm-10 col-md-9 col-lg-11 col-xl-10 col-xxl-9 px-5 py-5 my-5 me-3 my-from-lg-0 me-from-lg-0 row-gap-4 column-gap-5 d-flex flex-column flex-lg-row justify-content-between align-items-center align-items-lg-stretch favorite-rrom-white-px-sm-0'>
                    <div className='col-12 col-sm-11 col-lg-6'>
                        <img src={favoriteRoom.room_main_image} className='img-fluid' />
                    </div>

                    <div className='col-11 col-lg-6 d-flex flex-column justify-content-between align-items-start'>
                        <div>
                            <h1 className='text-title-1 text-white font-mont-semibold'>{i18n.language === 'en' ? favoriteRoom.translations?.en?.name : favoriteRoom.translations.uk.name}</h1>
                            <p className='text-white fs-5 font-mont-light'>{i18n.language === 'en' ? favoriteRoom.translations?.en?.description : favoriteRoom.translations.uk.description}</p>
                        </div>

                        <div className='col-12 my-2'></div>

                        <div>
                            <p className='text-white fs-4 font-mont-light'>{favoriteRoom.price} {t('room_price_daily')}</p>
                        </div>

                        <div className='col-12 col-md-8 col-xl-11 col-xxl-10 d-flex flex-row column-gap-2'>
                            <a href='/rooms/' className='col-6 text-white text-center fs-5 button-hover-right-fill-skin border border-color-skin py-2'>{t("check_all_rooms_button")}</a>
                            <a href='https://www.booking.com/hotel/ua/oaza-iasinia.cs.html#room_110467301' target="_blank" className='col-6 text-white text-center fs-5 bg-color-light-skin border border-color-skin py-2 buton-hover-skin'>{t("book_room_button")}</a>
                        </div>
                    </div>
                </div>
            </div>
        :
            <div className='row m-0 px-0 py-5 my-5 my-from-lg-0 d-flex justify-content-center'>
                <div className='col-sm-10 col-md-9 col-lg-11 col-xl-10 col-xxl-9 py-5 px-5 bg-white ms-from-lg-0 row-gap-4 column-gap-5 d-flex flex-column flex-lg-row-reverse justify-content-between align-items-center align-items-lg-stretch favorite-rrom-white-px-sm-0'>
                    <div className='col-12 col-sm-11 col-lg-6'>
                        <img src={favoriteRoom.room_main_image} className='img-fluid' />
                    </div>

                    <div className='col-11 col-lg-5 col-xl-5 d-flex flex-column justify-content-between align-items-start'>
                        <div>
                            <h1 className='text-title-1 text-dark font-mont-semibold'>{i18n.language === 'en' ? favoriteRoom.translations?.en?.name : favoriteRoom.translations.uk.name}</h1>
                            <p className='text-dark fs-5 font-mont-light'>{i18n.language === 'en' ? favoriteRoom.translations?.en?.description : favoriteRoom.translations.uk.description}</p>
                        </div>

                        <div className='col-12 my-2'></div>

                        <div>
                            <p className='fs-4 font-mont-light'>{favoriteRoom.price} {t('room_price_daily')}</p>
                        </div>

                        <div className='col-12 col-md-9 col-lg-12 col-xl-11 col-xxl-12 d-flex flex-row column-gap-2'>
                            <a href='/rooms/' className='col-6 text-dark text-center fs-5 button-hover-right-fill-dark border border-color-darker py-2'>{t("check_all_rooms_button")}</a>
                            <a href='https://www.booking.com/hotel/ua/oaza-iasinia.cs.html#room_110467301' target="_blank" className='col-6 text-white text-center fs-5 bg-color-darker border border-dark py-2 button-hover-darker'>{t("book_room_button")}</a>
                        </div>
                    </div>
                </div>
            </div>
        }   
    </div>
  )
}

export default FavoriteRooms